<script setup lang="ts">
import type { Language } from "../../types/navbar.types";

defineProps<{ languages: Language[] }>();
const switchLocalePath = useSwitchLocalePath();
</script>

<template>
  <LayoutDropdown class="language-drop-down">
    <!--    TODO: translation token-->
    <p class="language-drop-down__header">languages</p>
    <ul>
      <li v-for="language in languages" :key="language.code">
        <NuxtLink
          active-class="language-drop-down__link--active"
          class="language-drop-down__link"
          :href="switchLocalePath(language.slug)"
        >
          {{ language.title }}
        </NuxtLink>
      </li>
    </ul>
  </LayoutDropdown>
</template>

<style scoped lang="scss">
ul,
li {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.language-drop-down {
  &__header {
    font-size: 14px;
    color: var(--color-black-pressed, #555555);
  }

  &__link {
    font-weight: bold;
    text-decoration: none;
    font-size: 14px;
    line-height: 30px;

    &:hover {
      color: var(--primary-red, #ff0038);
    }
  }
}
</style>
